<svg [attr.width]="width$ | async" [attr.height]="height$ | async">
  <use [attr.href]="iconPath" />
</svg>
